import React, { useMemo } from "react";
import { UserData } from "@/entities/users/types";
import StakeholdersMapping from "./StakeholdersMapping";
import { useReport } from "@/entities/reporting/hooks";
import {
  OverallScoringData,
  ReportType,
  SettingsPeriod
} from "@/entities/reporting/types";

interface Props {
  leadUser?: UserData;
}

const StakeholdersMappingWrapper: React.FC<Props> = ({ leadUser }) => {
  const reportPeriod = SettingsPeriod.ALL_TIMES;

  const { report: overallReport, isLoading } = useReport(
    ReportType.KEY_STAKEHOLDERS_MAPPING_SCORE,
    reportPeriod
  );

  const overallData: OverallScoringData = useMemo(
    () => overallReport?.keyStakeholdersMappingScore?.overall ?? undefined,
    [overallReport]
  );

  return (
    <StakeholdersMapping
      leadUser={leadUser}
      overallData={overallData}
      period={reportPeriod}
      isLoading={isLoading}
    />
  );
};

export default StakeholdersMappingWrapper;
